<template>
  <div id="bee-plugin-container" class="border">
    <div
      v-show="!isInited || isError"
      class="flex h-full items-center justify-center gap-4 bg-cdp-main-primary-light"
    >
      <icon
        v-show="isInited"
        name="ic_system_warning"
        class="h-6 w-6 text-cdp-yellow-400"
      />
      {{ !isInited ? t('beefree_loading') : t('beefree_error') }}
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import beePlugin from '@mailupinc/bee-plugin';
import { ref, watch } from 'vue';
import axios from 'axios';
export default {
  name: 'ComponentsBeeFree',
  props: {
    data: {
      type: [String, Object],
      default: () => {}
    },
    clientId: {
      type: String,
      default: undefined
    },
    clientSecret: {
      type: String,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['save', 'syncInstance', 'send', 'error'],
  setup(props, { emit }) {
    const { t } = useI18n();

    const beePluginInstance = ref('');
    const isError = ref(false);
    const isInited = ref(false);
    const firstInitData = ref(false);

    const beeConfig = {
      uid: 'bee-clientside', // needed for identify resources of the that user and billing stuff
      container: 'bee-plugin-container', // Identifies the id of div element that contains BEE Plugin
      language: 'zh-HK',
      trackChanges: true,
      disableLinkSanitize: false,
      onSave(jsonfile, htmlfile) {
        const form = {
          jsonfile,
          htmlfile
        };
        emit('save', form);
      },
      onChange() {
        emit('syncInstance', beePluginInstance.value);
      },
      onSend(htmlfile) {
        emit('send', htmlfile);
      },
      onError(errorMessage) {
        emit('error', errorMessage);
      }
    };

    watch(
      () => props.data,
      async (data) => {
        if (!props.clientId || !props.clientSecret) {
          isError.value = true;
          return;
        }
        let beePluginData;
        try {
          if (!firstInitData.value) {
            const endpoint = 'https://auth.getbee.io/apiauth';
            const response = await axios.post(endpoint, {
              client_id: props.clientId,
              client_secret: props.clientSecret,
              grant_type: 'password'
            });

            beePluginData = response.data;

            if (beePluginData.access_token) {
              isError.value = false;
            } else {
              isError.value = true;
            }
            isInited.value = true;

            if (!beePluginData && !beePluginInstance.value) {
              return;
            }
            beePluginInstance.value = new beePlugin(beePluginData);
            const template = props.data ? JSON.parse(JSON.stringify(data)) : {};
            await beePluginInstance.value.start(beeConfig, template);
            emit('syncInstance', beePluginInstance.value);
            await beePluginInstance.value.load(template);
            firstInitData.value = true;
          } else {
            await beePluginInstance.value.reload(data);
          }
        } catch (error) {
          console.log(error);
        }
      },
      {
        deep: true,
        immediate: true
      }
    );

    return {
      t,
      isInited,
      isError
    };
  }
};
</script>

<style scoped lang="scss">
:deep(#bee-plugin-container__bee-plugin-frame) {
  // min-width: unset !important;
}
</style>